module.exports = __webpack_public_path__ + "img/intelligence.08203c24.png";